import { CanvasJSChart } from 'app/components/CanvasJs';
import React from 'react';
import { coresGraficoContaReceber } from './styles';

const ContaReceberGraficoSomatorios = ({ values }) => {
  return (
    <CanvasJSChart
      options={{
        culture: 'pt-br',
        animationEnabled: true,
        axisY: {
          prefix: 'R$',
          labelFontSize: 11,
        },
        toolTip: {
          shared: true,
        },
        legend: {
          fontSize: 16,
          cursor: 'pointer',
          verticalAlign: 'bottom',
        },
        data: [
          {
            type: 'pie',
            showInLegend: true,
            yValueFormatString: 'R$ ###,##0.00',
            indexLabel: '{label} - {y}',
            dataPoints: [
              {
                y: values.somatorioAVencer || 0,
                label: 'A vencer',
                color: coresGraficoContaReceber.azul,
                legendText: 'A vencer',
              },
              {
                y: values.somatorioBaixadas || 0,
                label: 'Baixadas',
                color: coresGraficoContaReceber.verde,
                legendText: 'Baixadas',
              },
              {
                y: values.somatorioParciais || 0,
                label: 'Parciais',
                color: coresGraficoContaReceber.laranja,
                legendText: 'Parciais',
              },
              {
                y: values.somatorioVencidas || 0,
                label: 'Atrasadas',
                color: coresGraficoContaReceber.vermelho,
                legendText: 'Atrasadas',
              },
            ],
          },
        ],
      }}
    />
  );
};

export default ContaReceberGraficoSomatorios;
